import React from "react";
import { motion } from "framer-motion";
import { LockIcon } from "lucide-react";
import { useDecreasingSlots } from "../hooks/useDecreasingSlots";
const TOTAL = 50;
const FLOOR = 2;
export function BonusSlots({
  started
}: {
  started: boolean;
}) {
  const slots = useDecreasingSlots(TOTAL, FLOOR, started);
  const taken = TOTAL - slots;
  const fill = taken / TOTAL * 100;
  return <div className="mt-3" data-id="element-14" data-mp="1xym7blb3r9k3">
      <div className="flex items-center justify-between gap-3 text-xs sm:text-sm" data-id="element-15" data-mp="1xzxgk0nbh9il">
        <span className="text-cocoa" data-id="element-16" data-mp="1szjer0cb6vt0">
          Incluido ahora solo para{" "}
          <motion.strong key={slots} className="inline-block font-bold tabular-nums text-alert" initial={{
          scale: 1.35
        }} animate={{
          scale: 1
        }} transition={{
          duration: 0.25,
          ease: [0.23, 1, 0.32, 1]
        }} data-id="element-17" data-mp="1o0g8xdoi8ljz">
            {slots}
          </motion.strong>{" "}
          cupos de {TOTAL}
        </span>
        <span className="inline-flex shrink-0 items-center gap-1 rounded-full bg-cream-dark px-2 py-0.5 font-semibold text-cocoa-faint" data-id="element-18" data-mp="3ddjqrpas6kk5">
          <LockIcon className="h-3 w-3" aria-hidden="true" data-id="element-19" data-mp="1mpwjlfqiemmb" />
          <span className="line-through" data-id="element-20" data-mp="1mnac1g3mc743">$47 USD</span>
        </span>
      </div>
      <div className="mt-2 h-2.5 w-full overflow-hidden rounded-full bg-cream-dark" role="progressbar" aria-valuemin={0} aria-valuemax={TOTAL} aria-valuenow={taken} aria-label={`Cupos ocupados: ${taken} de ${TOTAL}`} data-id="element-21" data-mp="17tnmajq6ijcj">
        <motion.div className="h-full rounded-full bg-alert" initial={false} animate={{
        width: `${fill}%`
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-22" data-mp="25g4l5tek950e" />
      </div>
      <p className="mt-1.5 text-xs text-cocoa-faint" data-id="element-23" data-mp="1vogxm3l4k847">
        Al completarse los cupos, los videos pasan a costar $47 USD por separado.
      </p>
    </div>;
}